export const getNotificationTypes = (notificationLicenses, licenses) => {
  const type = [];
  Object.keys(notificationLicenses).forEach((notificationType: string) => {
    if (licenses.includes(notificationLicenses[notificationType])) {
      type.push(notificationType);
    }
  });
  return type;
};
